import React, { useState } from 'react';
import classes from './pages.module.css';
import { Container } from "react-bootstrap";
import orel from '../image/orel.png';
import TextOption from '../components/Ui/text/textOption';
import classesUi from '../components/Ui/text/text.module.css';
import ListList from '../components/Ui/list/listList';

const Acts = () => {
    const [posts, setposts] = useState([
        {id:1, list: 'Концепция создания и развития сетей 5G/IMT-2020 в Российской Федерации (Приказ Минкомсвязи России № 923 от 2019 г.)'},
        {id:2, list: 'Федеральный проект «Информационная инфраструктура» национальной программы «Цифровая экономика Российской Федерации» (протокол от 24 декабря 2018 г. №16 президиума Совета при Президенте Российской Федерации по стратегическому развитию и национальным проектам)'},
        {id:3, list: 'Дорожная карта «Мобильные сети связи пятого поколения» (Протокол № 27 заседания президиума Правительственной комиссии по цифровому развитию, использованию информационных технологий для улучшения качества жизни и условий ведения предпринимательской деятельности от 16.11.2020 г.)'}
    ])
    const [posts2, setposts2] = useState([
        {id:1, list: 'Положениям постановления правительства Российской Федерации от 17 июля 2015 года №719 «О подтверждении производства промышленной продукции на территории Российской Федерации»;'},
        {id:2, list: 'Постановления правительства РФ от 10.07.2019 N 878 «О мерах стимулирования производства радиоэлектронной продукции на территории Российской Федерации»;'},
        {id:3, list: 'Федеральному закону от 26 июля 2017 г. N 187-ФЗ «О безопасности критической информационной инфраструктуры Российской Федерации».'}
    ])
    return(
        <>
            <div className={classes.actTop}>
                <Container fluid="md">
                    <div className={classes.actContent}>
                        <div className={classes.text}>
                            <h1>НОРМАТИВНЫЕ АКТЫ</h1>
                            <div className={classes.divider}></div>
                            <p>Проект реализуется в соответствии с национальными интересами, а это означает, что он соответствует стратегическим целям и приоритетам Российской Федерации. В проекте задействована команда опытных инженеров и техников, которые работают вместе над созданием высококачественного продукта, отвечающего потребностям рынка. Данный проект направлен на развитие телекоммуникационной инфраструктуры страны и повышение конкурентоспособности ее телекоммуникационного сектора.</p>
                        </div>
                        <img src={orel} alt="img-acts" />
                    </div>
                </Container>
                <div className={classes.topBg}></div>
            </div>
            <Container fluid="md">
                <div className={classes.actLists}>
                    <div className={classesUi.contBlock} style={{margin: '10px auto', padding: '10px 0'}}>
                        <TextOption post={{
                            id:1,
                            body: 'Стратегия компании «Пилот Телеком» полностью отвечает целям и требованиям государственной политики, содержащейся в нормативных документах:'
                        }} />
                        <div className={classes.actList}>
                            <ListList lists={posts} />
                        </div>
                    </div>
                    <div className={classesUi.contBlock} style={{margin: '10px auto', padding: '10px 0'}}>
                        <TextOption post={{
                            id:2,
                            body: 'Произведенное на предприятии оборудование соответствует требованиям государственной политики импортозамещения радиоэлектронной продукции:'
                        }} />
                        <div className={classes.actList}>
                            <ListList lists={posts2} />
                        </div>
                    </div>
                    <div className={classesUi.contBlock} style={{margin: '10px auto', padding: '10px 0'}}>
                        <TextOption post={{
                            id:3,
                            body: 'Стратегия компании «Пилот Телеком» полностью отвечает целям и требованиям государственной политики, содержащейся в нормативных документах:'
                        }} />
                    </div>
                </div>
            </Container>
        </>
    )
}

export default Acts;